import React from 'react';
import { ScrollReveal } from './useScrollReveal';
export function BonusesSection() {
  const bonuses = [{
    num: '01',
    emoji: '🚨',
    title: 'BONO 1 — Kit de Primeros Auxilios Para Discusiones de 10 Minutos',
    desc: 'Protocolo de emergencia para frenar una pelea antes de que cause daño real. Las frases exactas, la checklist de emergencia y la Tarjeta SOS para usar en el momento exacto en que todo empieza a escalar.',
    value: '$15.000'
  }, {
    num: '02',
    emoji: '💬',
    title: 'BONO 2 — Guía Express de Mensajes que Reparan en vez de Herir',
    desc: '45 mensajes listos para usar después de una pelea. La fórmula exacta para pedir perdón, bajar el orgullo y retomar el contacto sin sonar falso ni débil. Para usar hoy mismo.',
    value: '$12.000'
  }, {
    num: '03',
    emoji: '🔗',
    title: 'BONO 3 — Checklist de Reconexión de 7 Días Para Parejas Ocupadas',
    desc: 'Un reto de 10 minutos por día durante 7 días para recuperar cercanía, complicidad y contacto real. Con tracker diario y evaluación final. Sin excusas. Sin tiempo libre necesario.',
    value: '$12.000'
  }, {
    num: '04',
    emoji: '📋',
    title: 'BONO 4 — Plantillas de Acuerdos Sanos Para la Convivencia Diaria',
    desc: '12 plantillas listas para eliminar las discusiones repetidas sobre tareas, pantallas, familia, cansancio y tiempo. La hoja maestra de convivencia y el formato de revisión mensual.',
    value: '$10.000'
  }, {
    num: '05',
    emoji: '❓',
    title: 'BONO 5 — Miniguía de Preguntas Poderosas Para Volver a Conectar',
    desc: '120 preguntas organizadas en 5 niveles para romper el piloto automático y tener conversaciones reales. El ritual semanal de 15 minutos para salir de la rutina para siempre.',
    value: '$12.000'
  }, {
    num: '06',
    emoji: '🔄',
    title: 'BONO 6 — Workbook de Reinicio de Pareja Para Hacer en un Fin de Semana',
    desc: 'El plan completo de 48 horas para resetear la relación: diagnóstico honesto, limpieza emocional, acuerdos mínimos y ritual de cierre. Para usar cuando sienten que necesitan parar la pelota.',
    value: '$10.000'
  }];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-900 relative overflow-hidden cv-auto" data-id="element-19">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-gold-500/5 to-transparent pointer-events-none" data-id="element-20" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-21">
        <ScrollReveal direction="up" className="text-center mb-16" data-id="element-22">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 flex items-center justify-center gap-3" data-id="element-23">
            <span data-id="element-24">🎁</span> 6 BONOS ESTRATÉGICOS
          </h2>
          <div className="inline-block bg-gold-500/20 text-gold-400 font-bold px-4 py-1.5 rounded-full text-lg tracking-widest" data-id="element-25">
            SIEMPRE INCLUIDOS
          </div>
        </ScrollReveal>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-26">
          {bonuses.map((bonus, index) => <ScrollReveal key={index} direction="up" delay={index + 1} className="bg-navy-800 border border-navy-600 rounded-2xl p-6 relative overflow-hidden group hover:border-gold-500/50 transition-colors" data-id="element-27">
              <div className="absolute -right-4 -top-4 text-8xl font-black text-navy-700/50 group-hover:text-navy-700 transition-colors" data-id="element-28">
                {bonus.num}
              </div>

              <div className="relative z-10" data-id="element-29">
                <div className="text-3xl mb-4" data-id="element-30">{bonus.emoji}</div>
                <h3 className="text-xl font-bold text-white mb-3 pr-8" data-id="element-31">
                  {bonus.title}
                </h3>
                <p className="text-slate-400 text-sm mb-6 min-h-[80px]" data-id="element-32">
                  {bonus.desc}
                </p>

                <div className="flex items-center justify-between pt-4 border-t border-navy-700" data-id="element-33">
                  <span className="text-slate-500 line-through text-sm" data-id="element-34">
                    {bonus.value}
                  </span>
                  <span className="bg-green-500/20 text-green-400 font-bold px-3 py-1 rounded text-sm" data-id="element-35">
                    GRATIS
                  </span>
                </div>
              </div>
            </ScrollReveal>)}
        </div>

        <ScrollReveal direction="up" className="bg-gradient-to-r from-gold-600/20 via-gold-500/20 to-gold-600/20 border border-gold-500/30 rounded-2xl p-8 text-center max-w-3xl mx-auto glow-gold" data-id="element-36">
          <p className="text-xl md:text-2xl font-medium text-slate-300" data-id="element-37">
            Valor total bonos{' '}
            <span className="line-through text-slate-500 mx-2" data-id="element-38">$71.000</span>
            <span className="text-gold-400 font-bold block md:inline mt-2 md:mt-0" data-id="element-39">
              → GRATIS con tu MegaPack
            </span>
          </p>
        </ScrollReveal>
      </div>
    </section>;
}